import React from 'react';

export const SearchResultRow = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <>
    <div className="SearchResultRow">{children}</div>
    <style jsx>{`
      .SearchResultRow {
        display: flex;
        justify-content: space-between;
        color: black;
      }
    `}</style>
  </>
);
